import { AttachmentStatus } from './const';

export interface Message {
  id: number;
  isEdited: boolean;
  author: MessageAuthor;
  body: string;
  createdAt?: string;
  attachments: Attachment[];
}

export interface Attachment {
  title: string;
  url: string;
  mimeType?: string;
}

export interface MessageAuthor {
  id: number;
  name: string;
  type: 'tutor' | 'student' | 'assistant';
  avatarUrl?: string;
  hint?: string;
}

export interface AttachmentUpload {
  uuid: string;
  mimeType?: string;
  type?: AttachmentFileType;
  url?: string;
  previewUrl?: string;
  title: string;
  status: AttachmentStatus;
}

export interface MessageRequest {
  text: string;
  attachments: Attachment[];
}

export interface MessageEditContent {
  body: string;
  attachments: Attachment[];
}

export interface UploadProgress {
  uuid: string;
  // прогресс загрузки файла 0..100
  value: number;
}

export enum AttachmentFileType {
  image = 'image',
  video = 'video',
  other = 'other',
}
